<template>
  <div class="skeleton-content">
    <div class="skeleton-content__container">
      <div
        v-for="index in 2"
        :key="index"
        class="skeleton-content__container__topic"
      >
        <div class="skeleton-content__container__topic__info">
          <div
            class="skeleton-content__container__topic__info__section-number skeleton__content skeleton__animate--white"
          ></div>
          <h4
            class="skeleton-content__container__topic__info__name skeleton__title skeleton__animate--white"
          ></h4>
        </div>

        <ul class="skeleton-content__container__topic__content-list">
          <li
            v-for="index in 3"
            :key="index"
            class="skeleton-content__container__topic__content-list__item skeleton__animate--white"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PathContentSkel',
}
</script>

<style lang="scss" scoped>
.skeleton-content {
  display: flex;
  justify-content: center;
  background: linear-gradient(0deg, #111111, #111111),
    linear-gradient(180deg, #111111 0%, rgba(17, 17, 17, 0) 15.27%);
  padding: 60px 20px;

  @include desktop {
    padding: 60px 100px;
  }

  &__container {
    display: flex;
    max-width: 1400px;
    flex-flow: column;
    width: 100%;

    &__topic {
      display: flex;
      flex-flow: row wrap;
      gap: 20px;
      border-bottom: 1px solid var(--tundora-gray);
      padding: 40px 0;
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 0;
        border: none;
      }

      @include desktop {
        flex-flow: row nowrap;
      }

      &__info {
        width: 100%;

        @include desktop {
          width: 270px;
          flex-flow: column;
        }

        &__section-number {
          height: 14px;
          width: 60px;
        }

        &__name {
          margin: 0;
          width: 120px;
          height: 24px;

          @include mobile {
            height: 32px;
          }
        }
      }
      &__content-list {
        list-style-type: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-flow: column;
        width: 100%;
        gap: 10px;

        &__item {
          width: 100%;
          height: 127px;
          border-radius: 10px;
          @include mobile {
            height: 106px;
          }
        }
      }
    }
  }
}
</style>
